import React, {Component} from 'react';
import PropTypes from 'prop-types';
import firebase from 'firebase/app';
import 'firebase/database';
import FontAwesome from 'react-fontawesome';
import {EditorDialog} from '../editor-components';

/** @class CreateExhibitorDialog
  * A component for creating a new exhibitor.
  * @prop {boolean} show - determines if the dialog should be visible
  * @prop {function} onExit - callback triggered when the dialog exit button is clicked
  */
export default class CreateExhibitorDialog extends Component {
  /** @constructor
    * Constructs a new CreateExhibitorDialog instance
    */
  constructor(props) {
    super(props);
    this.state = {
      company: '',
      brand: '',
      contact: '',
      phone: '',
      email: ''
    }
    this.handleSave = this.handleSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  /** @function handleChange
    * Applies user changes to the state
    * @param {InputEvent} event - the triggering event
    */
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }
  /** @function handleSave
    * Applies the current state to the database,
    * clears the form, and closes the dialog.
    */
  handleSave(event) {
    event.preventDefault();
    // Create exhibitor
    firebase.database().ref(`/exhibitors`).push({
      company: this.state.company,
      brand: this.state.brand,
      contact: this.state.contact,
      email: this.state.email,
      phone: this.state.phone
    })
    .then(()=>{
      this.setState({
        company: '',
        brand: '',
        contact: '',
        phone: '',
        email: ''
      }, this.props.onExit);
    });
  }
  /** @method render
    * Renders the component
    */
  render() {
    const style={maxWidth: "80vw"}
    return (
      <EditorDialog show={this.props.show} onExit={this.props.onExit}>
        <h3>Add New Exhibitor</h3>
        <form onSubmit={this.handleSave} style={style}>
          <div className="input-group">
            <label htmlFor="company">Company Name</label>
            <input name="company" type="text"
              value={this.state.company}
              onChange={this.handleChange}
              required
              minLength={1}
              />
          </div>
          <div className="input-group">
            <label htmlFor="brand">Brand Name</label>
            <input name="brand" type="text"
              value={this.state.brand}
              onChange={this.handleChange}
              required
              minLength={1}
              />
          </div>
          <div className="input-group">
            <label htmlFor="contact">Company Contact</label>
            <input name="contact" type="text"
              value={this.state.contact}
              onChange={this.handleChange}/>
          </div>
          <div className="input-group">
            <label htmlFor="email">Contact Email</label>
            <input name="email" type="email"
              value={this.state.email}
              onChange={this.handleChange}
              />
          </div>
          <div className="input-group">
            <label htmlFor="phone">Contact Phone</label>
            <input name="phone" type="text"
              value={this.state.phone}
              onChange={this.handleChange}
              pattern="[0-9]{3}[ -][0-9]{3}[ -][0-9]{4}"
              />
          </div>
          <div className="button-group">
            <button type="submit" className="btn btn-success">
              <FontAwesome name="save"/>
              Save Exhibitor
            </button>
          </div>
        </form>
      </EditorDialog>
    );
  }
}

CreateExhibitorDialog.propTypes = {
  show: PropTypes.bool.isRequired,
  onExit: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/exhibitor-list/create-exhibitor-dialog.js